import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchCurrentUser, login, logout } from './api';
import type { LoginRequest, User } from './types';

export const authKeys = {
  all: ['auth'] as const,
  me: () => [...authKeys.all, 'me'] as const,
};

export function useCurrentUser() {
  return useQuery<User>({
    queryKey: authKeys.me(),
    queryFn: fetchCurrentUser,
    retry: false,
    staleTime: 60_000,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation<User, Error, LoginRequest>({
    mutationFn: login,
    onSuccess: (user) => {
      qc.setQueryData(authKeys.me(), user);
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation<void, Error>({
    mutationFn: logout,
    onSuccess: () => {
      qc.removeQueries({ queryKey: authKeys.all });
    },
  });
}
